import { render } from "./SensitiveDataItem.vue?vue&type=template&id=161b28f3&scoped=true&ts=true"
import script from "./SensitiveDataItem.vue?vue&type=script&lang=ts"
export * from "./SensitiveDataItem.vue?vue&type=script&lang=ts"

import "./SensitiveDataItem.vue?vue&type=style&index=0&id=161b28f3&scoped=true&lang=scss"

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161b28f3"]])

export default __exports__